import { render, staticRenderFns } from "./headerArea.vue?vue&type=template&id=246b6124&"
import script from "./headerArea.vue?vue&type=script&lang=js&"
export * from "./headerArea.vue?vue&type=script&lang=js&"
import style0 from "./headerArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports